import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const GlowFadeAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  drawBlastShape(ctx, e, e.maxRadius * (1 + progress * 0.5));
  const g = ctx.createRadialGradient(e.pos.x, e.pos.y, e.maxRadius * 0.8, e.pos.x, e.pos.y, e.maxRadius * (1.2 + progress));
  g.addColorStop(0, '#fff'); g.addColorStop(0.2, ctx.strokeStyle as string); g.addColorStop(1, 'transparent');
  ctx.fillStyle = g; ctx.fill();
};

registerBlastAnimation('GLOW_FADE', GlowFadeAnimation);
